export const FEEDBACK_FORM_TEST_IDS = {
    NAME_INPUT: 'feedback-form-name-input',
    EMAIL_INPUT: 'feedback-form-email-input',
    PHONE_NUMBER_INPUT: 'feedback-form-phone-number-input',
    MESSAGE_INPUT: 'feedback-form-message-input',
    SUBMIT_BUTTON: 'feedback-form-submit-button',
    TRY_AGAIN_BUTTON: 'feedback-form-try-again-button',
};
